export default "__VITE_ASSET__B0snplM8__"